// import { LibraryResourcesProvider } from "@pathwright/features/src/modules/library/browse/LibraryResourcesProvider"
import StoreBrowseContainer from "@pathwright/features/src/modules/store/StoreBrowseContainer"
import HomeAugmentationPopoverLayout from "@pathwright/features/src/modules/unified-home/augmentations/HomeAugmentationPopoverLayout"
import LibraryBrowse from "library/browse/components/LibraryBrowse"
import { hasStoreEnabled } from "./utils"

// school.platform_version is not availble when declaring
// static routes so this component acts as intermediate
// container to render LibraryBrowse or StoreBrowse.

const StoreOrLibraryBrowse = (props) => {
  return (
    <>
      <HomeAugmentationPopoverLayout />
      {hasStoreEnabled() ? (
        <StoreBrowseContainer {...props} />
      ) : (
        <LibraryBrowse {...props} />
      )}
    </>
  )
}

StoreOrLibraryBrowse.displayName = "StoreOrLibraryBrowse"

export default StoreOrLibraryBrowse
